var prevScrollTop = sessionStorage.getItem('/gramHistoryscrollTop');
if(prevScrollTop){
    if(window.performance && window.performance.navigation.type == 2){
        window.scrollTo( 0, prevScrollTop);
    }
}
(function () {
    //ga변수 에러 출력 방지
    dataLayer = (typeof dataLayer == 'undefined') ? [] : dataLayer;
    var MKTF30001_tmpl_story =
    '{{#each item, index in gramStoryList}}' +
    '<li class="story-item">' +
        '{{#if item.contentType == 02}}'+
            '<a href="gram/story-detail?storyId={{item.storyId}}" data-contents="{{item.title}}" class="story-link" >' +
        '{{#elsif item.contentType == 01}}'+
            '<a href="#videoPopup" data-contents="{{item.title}}" data-video-url="{{item.videoUrl}}" data-control="modal" class="story-link btn-story-video{{index}}">' +
        '{{/if}}'+
            '<span class="story-thumb">' +
            '<img class="responsive" src="{{item.listThumbnailPath}}" data-pc-src="{{item.listThumbnailPath}}" data-m-src="{{item.listThumbnailPath}}" alt="{{item.listThumbnailAltText}}">' +
            '<span class="story-category">{{item.categoryTypeName}}</span>' +
            '</span>' +
            '<strong class="story-tit">{{item.title}}</strong>' +
            // '<strong class="story-tit" style="color:#{{item.titleRgbCode || 000}}">{{item.title}}</strong>' +
        '</a>' +
    '</li>' +
    '{{/each}}';
  
    var storyVideoModal =
    '<article id="videoPopup" class="popup-wrap gram-video-wrap">'+
        '<section class="modal-video-asset">'+
            '<div class="video-asset">'+
            '</div>'+
        '</section>'+
        '<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>'+
    '</article>';
    var MKTF30001_tmpl_event =
    '<a href="{{url}}">' +
        '<img class="responsive" src="{{pcMainThumbnailPath}}" data-pc-src="{{pcMainThumbnailPath}}" data-m-src="{{mobileMainThumbnailPath}}" alt="{{pcMainThumbnailAltText || mobileMainAltText}}">' +
    '</a>';
    var recomJson = {
        video:  [
                {
                    //카드
                    videoLength: 'balance',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform01.png',
                    title: '초경량 vs 고성능',
                    //플레이어
                    url: '/lg5-common/videos/gram/balance/stu.mp4',
                    desc:'[밸런스 그램 - 대학생편] 초경량 vs 고성능',
                    tag:'#그램14 #12세대인텔코어 #999g'
                },
                // {
                //     videoLength: 'express',
                //     imgSrcPc: '/lg5-common/images/GRS/thumb-shortform06.png',
                //     title: '그램+view편',
                //     url: '/lg5-common/videos/gram/express/view.mp4',
                //     desc:'[그램 익스프레스] 그램+view편',
                //     tag:'#그램+view	#듀얼화면	#넓은화면'
                // },
                {
                    videoLength: 'ohae',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform08.png',
                    title: '프로세서편',
                    url: '/lg5-common/videos/gram/ohae/dev.mp4',
                    desc: '[오해했오? 오해해소!] 프로세서편',
                    tag:'#12세대인텔코어	#램성능22%향상	#SSD성능2배'
                },
                {
                    videoLength: 'balance',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform04.png',
                    title: '디스플레이 확장 vs 디스플레이 복제',
                    url: '/lg5-common/videos/gram/balance/work.mp4',
                    desc:'[밸런스 그램 - 회사원편] 디스플레이 확장 vs 디스플레이 복제',
                    tag:'#그램+view	#업무에필수	#회의에필수'
                },
                {
                    videoLength: 'express',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform07.png',
                    title: 'LG Glance by Mirametrix®편',
                    url: '/lg5-common/videos/gram/express/mira.mp4',
                    desc:'[그램 익스프레스] LG Glance by Mirametrix®편',
                    tag: '#얼굴시선감지	#커서이동	#화면잠금'
                },
                {
                    videoLength: 'ohae',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform09.png',
                    title: '외장그래픽편',
                    url: '/lg5-common/videos/gram/ohae/game.mp4',
                    desc: '[오해했오? 오해해소!] 외장그래픽편', 
                    tag: '#RTX2050	#신형아키텍쳐암페어	#고성능	'
                },

                {
                    videoLength: 'ohae',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform10.png',
                    title: '가벼움편',
                    url: '/lg5-common/videos/gram/ohae/music.mp4',
                    desc: '[오해했오? 오해해소!] 가벼움편', 
                    tag: '#12세대인텔코어	#RTX2050	#고성능'
                },
                {
                    videoLength: 'balance',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform03.png',
                    title: '스노우 화이트 vs 옵시디안 블랙',
                    url: '/lg5-common/videos/gram/balance/infl.mp4',
                    desc:'[밸런스 그램 - 패션 인플루언서편] 스노우 화이트 vs 옵시디안 블랙',
                    tag: '#그램16	#감성은미니멀	#디자인은고급'
                },
                {
                    videoLength: 'express',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform05.png',
                    title: '외장그래픽편',
                    url: '/lg5-common/videos/gram/express/external.mp4',
                    desc:'[그램 익스프레스] 외장그래픽편',
                    tag: '#RTX2050	#여유로운편집	#생생한영상'
                },
    

                {
                    videoLength: 'ohae',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform11.png',
                    title: '성능유지편',
                    url: '/lg5-common/videos/gram/ohae/yoga.mp4',
                    desc: '[오해했오? 오해해소!] 성능유지편', 
                    tag:' #듀얼팬쿨링	#히트파이프면적확장	#고성능'
                },
                {
                    videoLength: 'ohae',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform12.png',
                    title: '내구성편',
                    url: '/lg5-common/videos/gram/ohae/stu.mp4',
                    desc: '[오해했오? 오해해소!] 내구성편', 
                    tag: '#밀스펙	#극강의테스트	#외유내강'
                },
                {
                    videoLength: 'balance',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform02.png',
                    title: '360도 모드 vs 스타일러스 와콤펜',
                    url: '/lg5-common/videos/gram/balance/iller.mp4',
                    desc:'[밸런스 그램 - 일러스트레이터편] 360도 모드 vs 스타일러스 와콤펜',
                    tag:'#그램360	#텐트모드	#드로잉'
                },   
                {
                    videoLength: 'ohae',
                    imgSrcPc: '/lg5-common/images/GRS/thumb-shortform13.png',
                    title: '화면비편',
                    url: '/lg5-common/videos/gram/ohae/work.mp4',
                    desc: '[오해했오? 오해해소!] 화면비편', 
                    tag:'#16:10	#숨은정보까지	#대화면'
                },
        ],
    }
    var MKTF30001_tmpl_recom =
    '{{#each item,index in items}}' +
    '<div class="slide-conts ui_carousel_slide">'+
        '<a href="#shortsPopup" class="shorts-slide" data-contents="{{item.listTitle}}" data-video-idx="{{item.shortFormId}}" data-href="#shortsPopup"  data-control="modal">'+
            '<figure class="shorts-thumb">'+
                '<img src="{{item.listThumbnailPath}}" alt="{{item.listTitle}}">'+
            '</figure>'+
            '<div class="shorts-cont">'+
                '<strong class="shorts-tit">{{item.listTitle}}</strong>'+
                '<div class="btn-wrap">'+
                    '<span class="btn mix">숏폼 영상보기</span>'+
                '</div>'+
            '</div>'+
        '</a>'+
    '</div>'+
    '{{/each}}';
    var MKTF30001_tmpl_recom_video =
    '{{#each item in items}}' +
    '<div class="slide-conts ui_carousel_slide">'+
        '<div class="video-wrap">'+
            '<div class="shorts-video">'+
                '<video autoplay muted playsinline>'+
                '</video>'+
                '<button type="button" class="btn-short-play"><span class="blind">일시정지</span></button>'+
                '<button type="button" class="btn-sound"><span class="blind">음소거해제</span></button>'+
            '</div>'+
            '<div class="shorts-play-conts on">'+
                '<p class="shorts-desc">{{item.detailTitle}}</p>'+
                '<div class="shorts-hashtag">{{item.tag}}</div>'+
            '</div>'+
        '</div>'+
    '</div>'+
    '{{/each}}';

    var MKTF30001_tmpl_recom_product =
    '{{#each item in items}}' +
    '<div class="slide-conts ui_carousel_slide">'+
        '<div class="product-item">'+
            '<a href="{{item.linkUrl}}" class="product-link" data-contents="{{item.modelName}} / '+
                '{{#if item.newReviewFlag == "Y" && item.mallCount > 1}}'+'AI 리뷰픽'+
                '{{#else}}'+'일반리뷰'+
                '{{/if}}' + '">'+
                '<span class="product-img"><img src="{{item.mediumImageAddr}}" alt="{{item.modelDisplayName}}"></span>'+
                '{{#if item.newProductBadgeFlag == "Y"}}' +
                '<span class="product-flag">신제품</span>' +  // BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
                '{{/if}}' +
                '<div class="product-name">'+
                    '<span class="main-title"><span class="main">{{#raw item.modelDisplayNamePlusSpec}}</span></span>'+
                '</div>'+
                '<span class="product-code">{{item.modelName}}</span>'+
                // S : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제  // 리뷰가 있을 경우에만 사용
                //S : BTOCSITE-42881 렛츠그램에 AI 리뷰픽 확대안(개선) 적용
//                '{{#if item.newReviewFlag == "Y" && item.mallCount > 1}}' +
//                '<div class="product-aireview">'+
//                    '<div class="ai-box">'+
//                        '<span class="ai-tit">AI 리뷰픽</span>'+ // 20230419 텍스트 수정
//                        '<span class="ai-flag">{{item.attributeName}}</span>'+
//                    '</div>'+
//                    '<p class="ai-desc">{{item.sentence}}</p>'+
//                '</div>'+
//                '{{/if}}' +
                //E : BTOCSITE-42881 렛츠그램에 AI 리뷰픽 확대안(개선) 적용
                // E : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
            '</a>'+
        '</div>'+
    '</div>'+
    '{{/each}}';


    var MKTF30001 = {
        fullUrl: {
            'www.lge.co.kr':'https://www.lge.co.kr/',
            'wwwstg.lge.co.kr':'https://wwwstg.lge.co.kr/',
            'brandstg.lge.co.kr':'https://wwwstg.lge.co.kr/',
            'wwwdev50.lge.co.kr':'https://wwwdev50.lge.co.kr/',
            'branddev.lge.co.kr':'https://wwwdev50.lge.co.kr/',
            'localhost':'https://wwwdev50.lge.co.kr/',
            '10.':'https://wwwdev50.lge.co.kr/',
            'brandalpha.lge.co.kr':'https://brandalpha.lge.co.kr/',
            'brand.lge.co.kr':'https://www.lge.co.kr/',
        },
        publUrl: {
            jsonRecom: '/lg5-common/data-ajax/gram/retrieveRecommendProductList.json',
            jsonShort: '/lg5-common/data-ajax/gram/retrieveShorFormList.json',
            jsonStory: '/lg5-common/data-ajax/gram/메인_그램스토리.json',
            jsonEvent: '/lg5-common/data-ajax/gram/메인_그램이벤트.json',
            moreStory:'/html/GRC/MKTF30071.html',
            moreEvent:'/html/GRC/MKTF30081.html',
        },
        url: {
            jsonRecom:'/mkt/api/gram/retrieveRecommendProductList.lgajax',
            jsonShort:'/mkt/api/gram/retrieveShorFormList.lgajax',
            jsonStory: '/mkt/api/gram/retrieveGramStoryList.lgajax',
            jsonEvent: '/mkt/api/gram/retrieveGramEventList.lgajax?mainYn=Y',
            moreStory:'/gram/story-list',
            moreEvent:'/gram/event-list',
        },
        init: function () {
            var self = this;
            self.$el = $('.MKTF30001');
            self.$story = self.$el.find('.gram-story .story-list');
            self.$event = self.$el.find('.gram-event .event-banner');
            /*
            //키비주얼 비디오
            var $video = self.$el.find('.key-visuals video');
            self.$mainVideo = self.$el.find('.key-visuals video')[0];
            self.$mainVideoBtn = self.$el.find('.key-visuals .btn-short-play');
            self.$sndBtn = self.$el.find('.key-visuals .btn-sound');
            //키비주얼 비디오 poster
            $video.attr('poster-mo') || $video.attr('poster-mo','/lg5-common/images/GRS/img-gram-key-visuals-mo.jpg');
            $video.attr('poster-pc') || $video.attr('poster-pc','/lg5-common/images/GRS/img-gram-key-visuals.jpg');
            $video.attr('src-mo') || $video.attr('src-mo','/lg5-common/images/GRS/videos/gram-mo.mp4');
            $video.attr('src-pc') || $video.attr('src-pc','/lg5-common/images/GRS/videos/gram-pc.mp4');
            $(window).on('resizeend',function(){
                var attr = $(window).width() < 768 ?  $video.attr('poster-mo') : $video.attr('poster-pc');
                $video.attr('poster',attr);
                var src = $(window).width() < 768 ?  $video.attr('src-mo') : $video.attr('src-pc');
                var src = $(window).width() < 768 ?  $video.attr('src-mo') : $video.attr('src-pc');
                $video.html('<source src="'+src+'" type="video/mp4">')
            }).trigger('resizeend');
            var src = $(window).width() < 768 ?  $video.attr('src-mo') : $video.attr('src-pc');
            $video.html('<source src="'+src+'" type="video/mp4">')
            setVideo(self.$mainVideo, self.$mainVideoBtn, self.$sndBtn, true);
            //self.$mainVideo.playTrigger();
            //[쿠키] 최초 진입시만 비디오 플레이
            if(lgkorUI.getCookie("mainVideoPlay")){
                if(vcui.detect.isAndroid){
                    self.$mainVideo.pauseTrigger();
                }
            }else{
                self.$mainVideo.playTrigger();
            }
            lgkorUI.setCookie("mainVideoPlay", 'play', true); //BTOCSITE-34364 [Let's Gram] KV 영역 Video 업로드 요청드립니다.
            */

            /* [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선 - 영역 제거로 비활성화
            //스토리 연동
            self.$el.append(storyVideoModal);
            self.requestData(self.getUrl().jsonStory, {}, function (result) {
                var data = result.data[0];
                //랜덤하게 3개 리스트 출력
                var total = data.gramStoryList.length;
                data.gramStoryList = vcui.array.shuffle(data.gramStoryList);
                data.gramStoryList = data.gramStoryList.splice(0, 3);
                lists = vcui.template(MKTF30001_tmpl_story, data);
                self.$story.html(lists);
                var $btnMore = $('.gram-story .btn-wrap a');
                $btnMore.attr('data-contents','그램의 특별한 스토리 한번에 모아보기');
                //3개 이상일때만 더보기버튼
                if(total > 3){
                    $btnMore.attr('href',self.getUrl().moreStory);
                }else{
                    $btnMore.hide();
                }
            });
            */
            
            /* [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선 - 영역 제거로 비활성화
            //이벤트 연동
            self.requestData(self.getUrl().jsonEvent, {}, function (result) {
                var data = result.data[0];
                if (data.eventList && data.eventList.length > 0) {
                    lists = vcui.template(MKTF30001_tmpl_event, data.eventList[0]);
                    self.$event.html(lists);
                    self.$el.find('.gram-event .btn-wrap a').attr('data-contents','놓칠 수 없는 혜택 진행중인 이벤트');
                    self.$el.find('.gram-event .btn-wrap a').attr('href',self.getUrl().moreEvent);

                    //이벤트가 1개일때 더보기 버튼 비노출
                    if (data.listTotalCount > 1) {
                        self.$el.find('.gram-event .btn-wrap').show();
                    } else {
                        self.$el.find('.gram-event .btn-wrap').hide();
                    }
                } else {
                    $('.gram-event').hide();
                }
            });
            */

            /* [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선 - 영역 제거로 비활성화 (전시구좌 가이드배너로 대체)
            //홈버튼, 그램을 더욱 그램답게 (유저가이드)
            var fullUrl = self.getFullUrl();
            $('.gram-nav-wrap.mo-only .btn-home').attr('href',fullUrl);
            $('.user-guide .related-banner a.banner-supplies').attr('href',fullUrl+'care-accessories/laptop')
            $('.user-guide .related-banner a.banner-center').attr('href',fullUrl+'support/find-service-center')
            $('.user-guide .related-banner a.banner-counsel').attr('href',fullUrl+'bestshop/visit-store-reservation')
            */

            self.bindEvents();
            //브랜드소개(혁신의 상징) 스와이프
            var $tooltipBox = $('.tooltip-box.detail-info');
            // S : BTOCSITE-30698 렛츠그램 홈 USP 영역 수정
            $tooltipBox.append('<button type="button" class="btn-close"><span class="blind">닫기</span></button>');
            var $tooltipBtns = $('.btn-close');
            // E : BTOCSITE-30698 렛츠그램 홈 USP 영역 수정
            $tooltipBtns.on('click',function(e){
                e.preventDefault();
                $tooltipBox.removeClass('active');
            });

            //  S : [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선 - 영역 제거로 비활성화
            // var $brandSwaip = $('.brand-introduction .ui_carousel_1_slider');
            // var $brandSwaipList = $('.brand-introduction .ui_carousel_1_slider .slide-conts');
            // $brandSwaip.find('.slide-number').addClass('only-mo');
            // $brandSwaip.vcCarousel({
            //     infinite: true,
            //     autoplay: false,
            //     speed:150,
            //     waitForAnimate:false,
            //     slidesToShow: 1,
            //     touchThreshold: 100, 
            // }).vcCarousel('instance').on('carouselresize', function () {
            //     if ($(window).width() < 768) {
            //         $brandSwaip.find('.slide-content').css('padding-right', '11%')
            //     } else {
            //         $brandSwaip.find('.slide-content').css('padding', '0')
            //     }
            // }).on('carouselafterchange', function (e, instance) {                
            //     // S :  BTOCSITE-33376 렛츠그램 홈메인 영역 디자인 수정 요청
            //     if($brandSwaip.find('.ui_carousel_current.on .innovation').length > 0) {
            //         $brandSwaip.find('.indi-wrap').addClass('on');
            //         $brandSwaip.find('.slide-number.only-mo').addClass('on');
            //     }else {
            //         $brandSwaip.find('.indi-wrap').removeClass('on');
            //         $brandSwaip.find('.slide-number.only-mo').removeClass('on');
            //     }
                // E :  BTOCSITE-33376 렛츠그램 홈메인 영역 디자인 수정 요청

            //     instance = instance || $brandSwaip.vcCarousel('instance');
            //         $brandSwaip.find('.slide-number').attr('style','');
            //         $brandSwaip.find('.slide-number strong').text( instance.currentSlide+1);// BTOCSITE-33376 렛츠그램 홈메인 영역 디자인 수정 요청
            //         $brandSwaip.find('.slide-number>span').text(' / ' + $brandSwaipList.length);// BTOCSITE-33376 렛츠그램 홈메인 영역 디자인 수정 요청

            // }).on('carouselswipestart', function (e, instance) {
            //     $tooltipBtns.eq(0).trigger('click');
            // }).trigger('carouselresize').trigger('carouselafterchange');

            // for (var i = 1; i < $brandSwaipList.length; i++) {
            //     $brandSwaipList.eq(i).find('.brand-count strong').text(i+1);// BTOCSITE-33376 렛츠그램 홈메인 영역 디자인 수정 요청
            //     $brandSwaipList.eq(i).find('.brand-count>span').text('/ ' + $brandSwaipList.length )// BTOCSITE-33376 렛츠그램 홈메인 영역 디자인 수정 요청
            // }
            //  E : [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선 - 영역 제거로 비활성화
            
            //jammy링크분기(app일때 외부브라우저)
            // $('.jammy-banner>a').on('click',function(e){
            //     if (isApp()) {
            //         e.preventDefault();
            //         var url = $('.jammy-banner>a').attr('href');
            //         if (vcui.detect.isIOS) {
            //           var jsonString = JSON.stringify({
            //             command: "openLinkOut",
            //             url: url,
            //           });
            //           webkit.messageHandlers.callbackHandler.postMessage(jsonString);
            //         } else if (vcui.detect.isAndroid) {
            //           android.openLinkOut(url);
            //         }
            //     }
            // });
        },
        getUrl: function () {
            var self = this;
            if (window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('wwwdev50') > -1 || window.location.href.indexOf(':3010') > -1) {
                return self.publUrl;
            } else {
                return self.url;
            }
        },
        getFullUrl: function () {
            var self = this;
            var href = window.location.href;
            var fullUrl;
            for(var key in self.fullUrl){
                if(href.indexOf(key)>-1){
                    fullUrl = self.fullUrl[key]
                }
            }
            return fullUrl;
        },
        getVcIns: function (type) {
            if (type == 'shortsPopup carousel') {
                return $('#shortsPopup .ui_carousel_1_slider').vcCarousel('instance');
            }
        },
        bindEvents: function () {
            var self = this;
         
            //메인 키비주얼 비디오 아래 터치스크롤시 다음 컨텐츠로 바로가기( 모바일만 )
            if (vcui.detect.isMobile) {
                var isActive = false;
                var nextTop = $('.key-visuals').height();
                var $navMobile = $('.gram-nav-wrap.mo-only');
                var $html = $('html, body');
                var startY=0;
                var endY=0;
                var initStartY = 0;
                $(document).on('touchstart', function (e) {
                    isActive = true;
                })
                $(window).on('scrollstart', function () {
                    startY = $(this).scrollTop();
                    initStartY = 0;
                }).on('scroll', function () {
                    if(isActive){
                        initStartY++;
                        if(initStartY == 2){
                            endY = $(window).scrollTop();
                            if( nextTop-80  < $(window).scrollTop()){
                                $html.removeClass('overflow-y-hidden');
                            }else{
                                $html.addClass('overflow-y-hidden');
                                if ( startY - endY < 0) {
                                    $html.clearQueue().animate({ scrollTop: nextTop-40 }, 200, function(){
                                        $html.removeClass('overflow-y-hidden');
                                    });
                                }else{
                                    $html.removeClass('overflow-y-hidden');
                                }
                            }
                        }
                    }
                    if( nextTop-100  < $(window).scrollTop()){
                        !$navMobile.hasClass('bg-black') && $navMobile.addClass('bg-black');
                    }else{
                        $navMobile.hasClass('bg-black') && $navMobile.removeClass('bg-black');
                    }
                });
            }
            /*
            //키비주얼 하단 아이콘 위치 조절
            var $keyBtnSnd = $('.key-visuals .btn-sound');
            var $keyIconScroll = $('.key-visuals .icon-scroll');
            var $keyBtnPlay = $('.key-visuals .btn-short-play');
            $(window).on('scroll',function(){
                var top = $(window).scrollTop()
                if(top < 30){
                    $keyBtnSnd.css('position','fixed');
                    $keyIconScroll.css('position','fixed');
                    $keyBtnPlay.addClass('fixed')
                }else{
                    $keyBtnSnd.css('position','absolute');
                    $keyIconScroll.css('position','absolute');
                    $keyBtnPlay.removeClass('fixed')
                }
            }).trigger('scroll');
            */
            //스토리 모달 유투브 연동
            $(window).on('modalshow.modalmanager',function(e){
                if (e.target.id === 'videoPopup') {
                    void 0;
                    var src = $(arguments[1].opener).attr('data-video-url');
                    var videoTypeHtml = '';
                    if(src.indexOf('.mp4') > -1){
                        videoTypeHtml = '<video loop muted autoplay controls playsinline><source src="'+src+'" type="video/mp4"></video>';
                    }else if( src.indexOf('.webm') > -1){
                        videoTypeHtml = '<video loop muted autoplay controls playsinline><source src="'+src+'" type="video/webm"></video>';
                    }else{
                        videoTypeHtml = '<iframe src="'+src+'" id="videoPlayerCode" frameborder="0"  webkitallowfullscreen="1" mozallowfullscreen="1" allowfullscreen="1" allow="accelerometer;encrypted-media; gyroscope; picture-in-picture" sandbox="allow-scripts allow-same-origin allow-presentation" title="YouTube video player" width="640" height="360" ></iframe>'
                        if(vcui.detect.isMobile || $(window).width() < 768){
                            $('#videoPopup .video-asset').css('height','56.25vw');
                        }
                    }
                    $('#videoPopup .video-asset').html(videoTypeHtml);
                }
            }).on('modalhide.modalmanager',function(e){
                $('#videoPopup .video-asset').attr('style','');
                if (e.target.id === 'videoPopup') {
                    $('#videoPopup .video-asset').html('');
                }
            });

            //[S] BTOCSITE-78612 [LGE.COM] 렛츠그램 개선 새창 팝업 처리
            self.$el.on("click", '.quick-item a', function (e) {
                if (this.target == "_blank") {
                    e.preventDefault();
                    self.targetLink(this);
                }
            });
            //[E] BTOCSITE-78612 [LGE.COM] 렛츠그램 개선 새창 팝업 처리
        },
        requestData: function (_json, _post, _func) {
            var self = this;
            var ajaxUrl = _json;
            var postData = _post;
            lgkorUI.requestAjaxDataPost(ajaxUrl, postData, function (result) {
                _func(result);
            });
        },
        //[S] BTOCSITE-78612 [LGE.COM] 렛츠그램 개선 새창 팝업 처리
        targetLink: function (target) {
            var $target = $(target);
            if (isApp()) {
                // 앱 케이스
                if (vcui.detect.isIOS) {
                    var jsonString = JSON.stringify({ command: "openLinkOut", url: target.href });
                    webkit.messageHandlers.callbackHandler.postMessage(jsonString);
                } else {
                    android.openLinkOut(target.href);
                }
            } else {
                // 일반 브라우져
                window.open(target.href);
            }
        }
        //[E] BTOCSITE-78612 [LGE.COM] 렛츠그램 개선 새창 팝업 처리
    };
    //숏츠
    var MKTF30001_Shorts = {
        init: function () {
            var self=this;
            MKTF30001.requestData(MKTF30001.getUrl().jsonShort, {}, function (result) {
                var data = result.data[0];
                if(data.mainShortFormList){
                    if(data.mainShortFormList.length > 0){
                        var data = result.data[0];
                        self.shortFormList = data.shortFormList;
                        var dataRecomObj = { items: data.mainShortFormList }
                        lists = vcui.template(MKTF30001_tmpl_recom, dataRecomObj);
                        $('.shorts-carousel .ui_carousel_track').html(lists);
                        self.$shortCard = $('.shorts-carousel');
                        self.$shortSlide = $('#shortsPopup .ui_carousel_1_slider');
                        self.mainShortFormListLength = data.mainShortFormList.length
                        self.slidesToShow = self.mainShortFormListLength
                        if(self.mainShortFormListLength >= 3){
                            self.slidesToShow = 3;
                        }
                        
                        self.$shortCard.vcCarousel({
                            infinite: true,
                            slidesToScroll: 1,
                            slidesToShow: self.slidesToShow,
                            centerMode: true,
                            variableWidth: false,
                            touchThreshold: 15, 
                            preventVertical: true,  
                            responsive: [
                                {
                                    breakpoint: 768,
                                    settings: {
                                        touchThreshold: 15, 
                                        centerMode: true,
                                        slidesToScroll: 1,
                                        slidesToShow: 1,
                                        preventVertical: true,  
                                    }
                                },
                                {
                                    breakpoint: 1350,
                                    settings: {
                                        touchThreshold: 15, 
                                        centerMode: true,
                                        slidesToScroll: 1,
                                        slidesToShow: self.slidesToShow,
                                        preventVertical: true,  
                                    }
                                },
                                {
                                    breakpoint: 20000,
                                    settings: {
                                        touchThreshold: 15, 
                                        centerMode: true,
                                        slidesToScroll: 1,
                                        slidesToShow: self.slidesToShow,
                                        preventVertical: true,  
                                        
                                    }
                                }
                            ]
                        });
                        
                        self.$shortSlide.vcCarousel('instance') && self.$shortSlide.vcCarousel('instance').destroy();
                        self.$shortSlide.vcCarousel({
                            infinite: true,
                            arrows: true, 
                        });
                
                        self.$shortSlide.data('isCarousel',false);
                        var $short = $('#shortsPopup');
                        var dataRecomObj = { items: self.shortFormList }
                        lists = vcui.template(MKTF30001_tmpl_recom_video, dataRecomObj);
                        $short.find('.ui_carousel_track').html(lists);
                        self.bindEvents();
                        //$('#gram-shorts').css('visibility','visible').css('opacity','1');
                        return;
                    }
                }
                $('.shorts').hide();
            });
        },
        bindEvents: function () {
            var self=this;
            var idx = Math.floor(Math.random()*(recomJson.video.length-1)); 
            //var idx = 0
            //self.$shortCard.css('visibility','visible');
            //숏츠 카드 스와이프 이벤트
            self.$shortCardSlide = $('.shorts-carousel .shorts-slide');
            self.$shortCardSlideBtn = $('.shorts-carousel .shorts-cont a');
            self.$shortCardNumber = $('.shorts-carousel .slide-number');
            self.$shortCard.vcCarousel('instance').on('carouselswipestart', function (e, instance) {
                self.$shortCardSlide.removeClass('over');
            }).on('carouselafterchange', function (e, instance) {
                $('.shorts-carousel .shorts-slide').removeClass('over');
                self.$shortCard.find('.ui_carousel_current').find('.shorts-slide').addClass('over');
                instance = instance || self.$shortCard.vcCarousel('instance');
                setNumber(String(instance.currentSlide + 1));
                self.$shortCardNumber.find('.current').text( instance.currentSlide + 1 );// BTOCSITE-33376 렛츠그램 홈메인 영역 디자인 수정 요청
                self.$shortCardNumber.children('span').text(' / ' + instance.$slides.length);// BTOCSITE-33376 렛츠그램 홈메인 영역 디자인 수정 요청
                self.accessibility();
            }).on('carouselresize', function () {
                var $sw = $('.slide-wrap');
                $sw.removeClass('w1350').removeClass('w1024').removeClass('w768');
                var w = $(window).width();
                if ( w < 768) {
                    $sw.addClass('w768');
                } else if ( w< 1024) {
                    $sw.addClass('w1024');
                } else if ( w < 1350) {
                    $sw.addClass('w1350');
                } 
                if(self.mainShortFormListLength <= 3){
                    self.$shortCardSlide.addClass('length3')
                    var w = $(window).width();
                    if ( w < 768 ) {
                        if(self.mainShortFormListLength < 1){
                            //self.$shortCard.vcCarousel('instance').slideHandler(idx,false,true);
                        }
                        self.$shortCardSlide.removeClass('length3')
                    }
                }else{
                    //self.$shortCard.vcCarousel('instance').slideHandler(idx,false,true);
                }
                //self.$shortCard.vcCarousel('instance').trigger('carouselafterchange');
                self.accessibility();
            });
            $(window).trigger('resize');
            self.$shortCard.vcCarousel('instance').trigger('carouselafterchange');
            $('#shortsPopup .pop-conts').css('opacity','0')
            self.$shortCardSlide.on('click', function (e) {
                e.preventDefault();
                self.idx = Number($(this).attr('data-video-idx'));
                for(var i=0; i<self.shortFormList.length; i++){
                    if(self.shortFormList[i].shortFormId == self.idx){
                        self.idx = i;
                        return;
                    }   
                }
            })
            //숏츠 모달 스와이프 이벤트
            $(window).on('modalshown', function (e) {
                if (e.target.id === 'shortsPopup') {
                    if(self.$shortSlide.data('isCarousel') === true){
                        self.$shortSlide.vcCarousel('instance').slideHandler(self.idx,false,true);
                        $('#shortsPopup .pop-conts').css('opacity','1')
                        return;
                    }
                    var $shortSlide = self.$shortSlide;
                    var instance = $shortSlide.vcCarousel('instance');
                    instance.reinit();
                    instance.setOption({arrows: true})
                    instance.refresh();
                    self.$shortSlide.data('isCarousel',true)
                    //스와이프 타겟 벗어남 이벤트
                    $shortSlide.on('mouseleave',function(e){
                        $shortSlide.find('.ui_carousel_slide').trigger('touchend').trigger('mouseup');
                    });
                    setTimeout(function(){
                        instance.on('carouselbeforechange', function(e, instance){
                            void 0;
                            for(var i=0; i<$shortSlide.find('.slide-conts').length; i++){
                                var $slide = $shortSlide.find('.slide-conts').eq(i);
                                var $sVideo = $slide.find('video')[0]
                                if($sVideo.pauseTrigger){
                                    $sVideo.pauseTrigger();
                                }
                            }
                        }).on('carouselafterchange', function(e, instance){
                            void 0;
                            var idx = instance.currentSlide;
                            var srcHtml = '<source src="'+self.shortFormList[idx].videoUrl+'" type="video/mp4">'
                            var $current = $shortSlide.find('.slide-conts').eq(idx+1);
                            if( $current.find('video source').length == 0){
                                $current.find('video').html(srcHtml).attr('loop',true)
                                var $video =  $current.find('video')[0];
                                var $videoBtn =  $current.find('.btn-short-play');
                                var $sndBtn = $current.find('.btn-sound');
                                $sndBtn.css('z-index',1);
                                var label = $current.find('.shorts-play-conts .shorts-desc').text();
                                $videoBtn.data('ga',{				
                                    'event': 'customEvent',				
                                    'customEventCategory': '비디오',				
                                    'customEventAction': 'Video - Start',				
                                    'customEventLabel': '비디오 타이틀 : '+ label
                                })
                                setVideo($video, $videoBtn, $sndBtn);
                            }
                            for(var i=0; i<$shortSlide.find('.slide-conts').length; i++){
                                var $slide = $shortSlide.find('.slide-conts').eq(i);
                                var $vBtn =  $slide.find('.btn-short-play');
                                var $sVideo = $slide.find('video')[0];

                                if($slide.hasClass('ui_carousel_current')){
                                    if($sVideo.playTrigger){
                                        $sVideo.playTrigger();
                                        var obj = $vBtn.data('ga')
                                        dataLayer.push(obj);	
                                    }
                                }
                            }
                            self.accessibility();
                        }).slideHandler(self.idx,false,true);
                        $('#shortsPopup .pop-conts').css('opacity','1')
                    },500);

                    $('#shortsPopup').each(function() {
                        var $this = $(this);
                        
                        if ($this.is(':visible')) {
                            $this.off('keydown.acc').on('keydown.acc', function(e) {
                                var $target = $(e.target);

                                if (e.keyCode === 9 && e.shiftKey) {
                                    if ($target.hasClass('popup-wrap')) {
                                        e.preventDefault();
                                        $this.find('.ui_modal_close').focus();
                                    }
                                } else if (e.keyCode === 9) {
                                    if ($target.hasClass('ui_modal_close')) {
                                        e.preventDefault();
                                        $this.focus();
                                    }
                                }
                            });
                        }
                    });
                }
            }).on('modalhide', function (e) {
                if (e.target.id === 'shortsPopup') {
                    var $shortSlide = $('#shortsPopup .ui_carousel_1_slider');
                    for(var i=0; i<$shortSlide.find('.slide-conts').length; i++){
                        var $sVideo = $shortSlide.find('.slide-conts').eq(i).find('video')[0]
                        $sVideo.pauseTrigger && $sVideo.pauseTrigger();
                    }
                    $('#shortsPopup .pop-conts').css('opacity','0')
                }
            });
        },
        accessibility: function() {
            var self = this;
            self.$shortCard.find('.slide-conts').each(function() {
                var $this = $(this);
                var shortsSlide = $this.find('a');

                $this.removeClass('on');
                $this.attr('aria-hidden', true);
                shortsSlide.attr('tabindex', '-1');

                if ($this.hasClass('ui_carousel_center') && !$this.hasClass('ui_carousel_cloned')) {
                    $this.addClass('on');
                    $this.attr('aria-hidden', false);
                    shortsSlide.removeAttr('tabindex');
                }
            });

            self.$shortSlide.each(function() {
                var $this = $(this);

                if (!self.$shortSlide.is(':visible')) {
                    return;
                }

                $this.find('.slide-conts').each(function() {
                    var $this = $(this);
                    
                    $this.find('button').attr('tabindex', '-1');

                    if ($this.hasClass('on')) {
                        $this.find('button').removeAttr('tabindex');
                    }
                });
            });
        }

    }
    //추천제품 PC
    //  S : [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선 - 영역 제거로 비활성화
    // var MKTF30001_RecomPc = {
    //     init:function(){
    //         var self = this;
    //         var $introSwaip = $('.gram-introduction .product-carousel'); 
    //         $introSwaip .vcCarousel({
    //             infinite: true,
    //             // autoplay: false,
    //             slidesToScroll: 1,
    //             slidesToShow: 4,
    //             centerMode: true,
    //             centerPadding: '0px',
    //             preventVertical: true,  
    //             responsive: [
    //                 {
    //                     breakpoint: 1024,
    //                     settings: {
    //                         infinite: true,
    //                         // autoplay: false,
    //                         slidesToScroll: 1,
    //                         slidesToShow: 3,
    //                         centerMode: false,
    //                         centerPadding: '0px',
    //                         preventVertical: true,  
    //                     }
    //                 },
    //                 {
    //                     breakpoint: 1280,
    //                     settings: {
    //                         infinite: true,
    //                         // autoplay: false,
    //                         slidesToScroll: 1,
    //                         slidesToShow: 3,
    //                         centerMode: false,
    //                         centerPadding: '0px',
    //                         preventVertical: true,  
    //                     }
    //                 },
    //                 {
    //                     breakpoint: 20000,
    //                     settings: {
    //                         infinite: true,
    //                         // autoplay: false,
    //                         slidesToScroll: 1,
    //                         slidesToShow: 4,
    //                         centerMode: false,
    //                         centerPadding: '0px',
    //                         preventVertical: true,  
    //                     }
    //                 }
    //             ]
    //         })
    //         MKTF30001.requestData(MKTF30001.getUrl().jsonRecom, {mainYn:'Y'}, function (result) {
    //             var data = result.data[0];
    //             if(data.recommendProductList){
    //                 if(data.recommendProductList.length > 0){
    //                     var dataRecomObj = { items: data.recommendProductList }
    //                     lists = vcui.template(MKTF30001_tmpl_recom_product, dataRecomObj);
    //                     $('.gram-introduction .product-carousel .ui_carousel_track').html(lists);
    //                     var $introSwaipList = $('.gram-introduction .product-carousel .slide-conts');
    //                     $introSwaip.attr('data-length',$introSwaipList.length );
    //                     if ($introSwaipList.length <= 4) {
    //                         $('.gram-introduction').addClass('slide-count' + $introSwaipList.length);
    //                     }
    //                     $introSwaip.vcCarousel('instance').reinit();
    //                     $('.product-aireview').hide();
    //                     self.bindEvents();
    //                     MKTF30001_RecomMo.init();
    //                     //$('.gram-introduction').css('visibility','visible').css('opacity','1');
    //                     return;
    //                 }
    //             }
    //             $('.gram-introduction').hide();
    //         });
    //     },
    //     bindEvents: function () {
    //         var $introSwaip = $('.gram-introduction .product-carousel'); 
    //         $introSwaip.vcCarousel('instance').on('carouselresize', function () {
    //             $('.card-slide-wrap .slide-number').show();
    //             if ($(window).width() < 768) {
    //                 $introSwaip.hide();
    //                 $('.card-slide-wrap').show();
                    
    //             } else {
    //                 $introSwaip.show();
    //                 $('.card-slide-wrap').hide();
    //             }
    //         }).trigger('carouselresize');
    //     }
    // }

    //추천제품 MO
    // var MKTF30001_RecomMo = {
    //     init:function(){
    //         var $introSwaip = $('.gram-introduction .product-carousel .ui_carousel_slide');
    //         var $introInner = $('.gram-introduction .main-inner');
    //         if($('.card-slide-wrap').length == 0){
    //             //$introInner.append('<div class="card-slide-wrap"><div class="ui-card-slide"></div><div class="slide-number"><strong class="current"><span class="blind">현재 페이지</span>1</strong><span><span class="blind">전체 페이지</span>/10</span></div></div>');
    //             $introInner.append('<div class="card-slide-wrap"><div class="ui-card-slide"></div></div>');
    //         }
    //         var $cardWrap = $('.card-slide-wrap');
    //         var slideHtml = '';
    //         var mIdx=0;
    //         for (var i = 0; i < $introSwaip.length; i++) {
    //             if(!$introSwaip.eq(i).hasClass('ui_carousel_cloned')){
    //                 slideHtml += '<div class="card-slide" data-idx="' + mIdx + '" >' + $introSwaip.eq(i).find('.product-link')[0].outerHTML + '</div>';
    //                 mIdx++;
    //             }
    //         }
    //         $introInner.find('.ui-card-slide').html(slideHtml);
    //         var $introSwaipList = $('.gram-introduction .product-carousel .slide-conts');
    //         if ($introSwaipList.length <= 1) {
    //             return;
    //         }
    //         var $uiCardSlide = $('.ui-card-slide');
    //         var $dragCardTarget;
    //         var isMove = true;
    //         var startX = 0;
    //         var startY = 0;
    //         var moveX = 0;
    //         var moveY = 0;
    //         var transX = -40;
    //         var timeId = null
    //         for (var i = 0; i < $uiCardSlide.find('.card-slide').length; i++) {
    //             $uiCardSlide.find('.card-slide').eq(i).addClass('card-slide' + i);
    //         }
    //         $cardWrap.on('mousedown touchstart', function (e) {
    //             moveX = 0;
    //             moveY = 0;
    //             startX = e.targetTouches ? e.targetTouches[0].clientX : e.clientX;
    //             startY = e.targetTouches ? e.targetTouches[0].clientY : e.clientY;
    //             // e.preventDefault();
    //             //$('.gram-story h3').append('<span style="font-size:9px;"> touchstart </span>')
    //             if ($(e.target).hasClass('card-slide') && $(e.target).hasClass('on')) {
    //                 $dragCardTarget = $(e.target);
    //             }
    //         }).on('mousemove touchmove', function (e) {
    //             //e.preventDefault();
    //             moveX = e.targetTouches ? e.targetTouches[0].clientX : e.clientX;
    //             moveX = moveX - startX;
    //             moveY = e.targetTouches ? e.targetTouches[0].clientY : e.clientY;
    //             moveY = moveY - startY;
    //             if(Math.abs(moveX) > Math.abs(moveY)&&$dragCardTarget){
    //                 $dragCardTarget.css('left', moveX + 'px');
    //             }
    //         }).on('mouseup touchend', function (e) {
    //             //clearTimeout(timeId)
    //             if (Math.abs(moveX) < 0.6 && Math.abs(moveY) < 0.6 ) {
    //                 //console.log($uiCardSlide.find('.card-slide').eq(0).find('a').attr('href'));
    //                 window.location.href = $uiCardSlide.find('.card-slide').eq(0).find('a').attr('href');
    //             }
    //             if (transX > moveX) {
    //                 next();
    //             } else {
    //                 $dragCardTarget && $dragCardTarget.animate({ left: 0 }, 300);
    //             }
    //             // timeId = setTimeout(function(){
    //             //     //isMove = true;
    //             // },500);
    //         })
    //         function autoNext() {
    //             setInterval(function(){
    //                 next();
    //             },3000)
    //         }
    //         function setIndi() {
    //             // var curIdx = Number($uiCardSlide.find('.card-slide').eq(0).attr('data-idx'))+1;
    //             // var totalIdx = $uiCardSlide.find('.card-slide').length;
    //             // $cardWrap.find('.slide-number strong').text( setNumber(curIdx));
    //             // $cardWrap.find('.slide-number>span').text('/' + setNumber(totalIdx))
    //         }
    //         function next() {
    //             var totalIdx = $uiCardSlide.find('.card-slide').length;
    //             $dragCardTarget = $uiCardSlide.find('.card-slide').eq(0);
    //             $dragCardTarget.css('transform', 'translateX(-500px)')
    //             setTimeout(function () {
    //                 $dragCardTarget.removeClass('on')
    //                 $uiCardSlide.find('.card-slide').eq(totalIdx-1).after($dragCardTarget)    
    //                 $uiCardSlide.find('.card-slide').eq(0).addClass('on');
    //                 $uiCardSlide.find('.card-slide').attr('style', '')
    //             }, 300);
    //         };
    //         function setMove(idx) {
    //             $uiCardSlide.find('.card-slide').removeClass('on')
    //             for (var i = 0; i < $uiCardSlide.find('.card-slide').length; i++) {
    //                 if (idx <= i) {
    //                 } else {
    //                     $uiCardSlide.find('.card-slide' + i).appendTo($uiCardSlide);
    //                 }
    //             }
    //             $uiCardSlide.find('.card-slide' + idx).addClass('on');
    //         }
    //         setMove(0);
    //         setIndi();
    //         $('.gram-introduction .product-carousel').vcCarousel('instance').trigger('carouselresize');
    //     }
    // }
    //  E : [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선 - 영역 제거로 비활성화

    var MKTF30001_HeroBnr = {
        init:function(){
            var $heroSlide  = $('.hero-banner');
            var isHeroVideo = false;
            var deviceType = ''
            $heroSlide.vcCarousel({
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                swipeToSlide: true,
                dotsSelector: ".ui_wideslider_dots",
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: false,
                touchThreshold: 100,
                cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                speed: 300,
            }).on("carouselbeforechange", function (e, slide, prev, next) {
                var $video = $(slide.$slides.get(prev)).find("video");
                if ($video.length > 0) {
                    $video.get(0).pause();
                    $video.get(0).currentTime = 0;
                    $video.get(0).muted = true;
                    $video.siblings(".video-button-wrap").find(".video-button").removeClass("pause");
                }
            }).on("carouselafterchange", function (e, slide, prev, next) {
                setHeroBanner();
                var $video = $(slide.$slides.get(prev)).find("video");
                if ($video.length > 0) {
                    // $heroSlide.vcCarousel("stop");
                    //$video.get(0).play();
                    loadedPlay($video);
                    $video.siblings(".video-button-wrap").find(".video-button").addClass("pause");
                    $video.siblings(".sound-button-wrap").find(".sound-button").addClass("muted");

                    $video.siblings(".video-button-wrap").find('.blind').text('일시정지');
                    $video.siblings(".sound-button-wrap").find('.blind').text('음소거 해제');
                }
            })
            $(".video-button-wrap").find(".video-button").find('.blind').text('일시정지');
            $(".sound-button-wrap").find(".sound-button").find('.blind').text('음소거 해제');

            $heroSlide.find('a[data-video-url]').on('click',function(){
                isHeroVideo = true;
            });
            $heroSlide.find('.video-button').on("click", function (e) {
                e.preventDefault();
                //if($(this).parent().siblings("video").data(deviceType + "-loadeddata") != true){return;}
                
                if ($(this).hasClass("pause")) {
                    $(this).removeClass("pause");
                    $(this).parent().siblings("video").get(0).pause();
                    $(this).find('.blind').text('재생')
                } else {
                    $(this).addClass("pause");
                    //$(this).parent().siblings("video").get(0).play();
                    loadedPlay($(this).parent().siblings("video"));
                    $(this).find('.blind').text('일시정지')
                }
            });
            $heroSlide.find('.sound-button').on("click", function () {
                //if($(this).parent().siblings("video").data(deviceType + "-loadeddata") != true){return;}
                
                if ($(this).hasClass("muted")) {
                    $(this).removeClass("muted");
                    $(this).parent().siblings("video").get(0).muted = false;
                    
                    $(this).find('.blind').text('음소거')
                } else {
                    $(this).addClass("muted");
                    $(this).parent().siblings("video").get(0).muted = true;

                    $(this).find('.blind').text('음소거 해제')
                }
            });    
            $heroSlide.find('video').on('ended', function () {
                $(this).siblings(".video-button-wrap").find(".video-button").removeClass("pause");
                // $heroSlide.vcCarousel("play");
                // $heroSlide.vcCarousel("next");
            });
            function setHeroBanner(isFirst) {
                var heroList = $(".hero-banner .slide-track > li");
                var heroListCurrent = $(".hero-banner .slide-track > li.ui_carousel_current");
                var heroListAct = heroList.siblings(".ui_carousel_current").index();
                var heroListLength = heroList.length;
                var heroListVideoLength = heroList.find("video").length;
                var custom = $(".hero-banner .custom-indi-wrap");
                var customControlButton = custom.find(".indi-control.ui_carousel_play");
                var slideCurrent = custom.find(".slide-page .current");
                var slideCount = custom.find(".slide-page .count");
        
                if (heroListLength > 1) {
                    custom.css("display", "flex");
                    slideCurrent.text(heroListAct);
                    slideCount.text(heroListLength - 2);
                    //console.log('current : '+heroListAct,'total : '+(heroListLength - 2));
                }
                if (isFirst === true) {
                    // if (heroListVideoLength > 0) {
                    //     $heroSlide.vcCarousel("stop");
                    //     customControlButton.css("display", "none");
                    // } else {
                    //     customControlButton.css("display", "block");
                    // }
                    // if (heroListCurrent.find("video").length > 0) {
                    //     //heroListCurrent.find("video").get(0).play();
                    //     loadedPlay(heroListCurrent.find("video"))
                    //     heroListCurrent.find("video").siblings(".video-button-wrap").find(".video-button").addClass("pause");
                    // }
                    // //BTOCSITE-54114 비디오 1개일때 반복 재생
                    // if(heroListVideoLength == 1){
                    //     heroListCurrent.find("video").prop('loop',true)
                    // }
                    // ////BTOCSITE-54114 비디오 1개일때 반복 재생

                    // BTOCSITE-78612 렛츠 그램 개선
                    if (heroListCurrent.find("video").length > 0) {
                        loadedPlay(heroListCurrent.find("video"))
                        heroListCurrent.find("video").siblings(".video-button-wrap").find(".video-button").addClass("pause");
                        // heroList.find("video").prop('loop', true);
                    }
                    // BTOCSITE-78612 렛츠 그램 개선
                }
            }
            function loadedPlay($video){
                $video.get(0).play();
            }
            function setSrc(type) {
                deviceType = type;
                var $videos = $heroSlide.find("video[data-pc-src]");
                $videos.each(function (index, item) {
                    var $item = $(item);
                    var fullUrl = MKTF30001.getFullUrl();
                    fullUrl = fullUrl.substr(0,fullUrl.length-1)
                    var src = fullUrl +$item.data(type + "-src");
                    var poster = fullUrl +$item.data(type + "-poster");
                    if ( $item.attr("src") != src ) {
                        $item.attr("src", src);
                    }
                    hasAudio( $item, src )

                    if ($item.attr("poster") !== poster) {
                        $item.attr("poster", poster);
                    }
                });
                setHeroBanner(true);
            }
            function hasAudio ($video, src) {
                if($video.attr('data-is-audio') == 'true' || src.indexOf('newjeans') == -1) {
                    $video.siblings(".sound-button-wrap").show()
                    void 0;
                } else{
                    $video.siblings(".sound-button-wrap").hide()
                    void 0;
                }
            }
        
            $(window).on('resizeend',function(){
                if(window.innerWidth < 768) {
                    setSrc('mo');
                }else if(window.innerWidth >= 768 && window.innerWidth <= 1024 ){
                    setSrc('ta');
                }else{
                    setSrc('pc');
                }
            }).trigger('resizeend');

        }
    }
    function setNumber(_num){
        if(String(_num).length == 1){
         return '0'+_num;
        } 
        return _num;
    }
    //비디오 플레이어
    function setVideo(_$video, _$btnPlay, _$btnMute, _isVideoSrc) {  
        //로딩바 추가
        var $parent = $(_$video).parent();
        //console.log('ddd'+$parent.find('.loading-video').length );
        if( $parent.find('.loading-video').length == 0){
            //lgkorUI.showLoading();
            //console.log($parent);
            $parent.append('<div class="loading-video"></div>');
        }
        $parent.find('.loading-video').fadeOut(0).fadeIn(0); //BTOCSITE-39373 렛츠그램 새로운 로딩바 적용 요청
        _$video.load();
        _$video.onloadedmetadata  = function() {
            loadeddata()
        }
        // _$video.onloadeddata = function() {
        //     loadeddata()
        // };
        function loadeddata(){
           //console.log('onloadeddata');
           $parent.find('.loading-video').fadeOut(300);
           setTimeout(function(){
               $parent.find('.loading-video').fadeOut(300);
           },1000)
           $(window).on('resizeend',function(){
               resizeEnd();
           });
           function resizeEnd(){
               $(_$video).removeClass('width100').removeClass('height100');
               if( $(window).height() < $(_$video).height() ){
                   $(_$video).removeClass('width100').addClass('height100');
               }else{
                   $(_$video).removeClass('height100').addClass('width100');
               }
           }
           resizeEnd();
        }

        var isPlaying = true;
        _$video.onplaying = function() {
            isPlaying = true;
            //console.log('onplaying');
        };
        _$video.onpause = function() {
            isPlaying = false;
            //console.log('onpause');
        };
        _$video.playTrigger = function () {
            if (_$video.paused && !isPlaying || _$video.paused && _isVideoSrc) {
                _$video.play();
                _$btnPlay.addClass('on')
                if(_$btnPlay.parent().parent().find('.shorts-play-conts').length > 0){
                    _$btnPlay.parent().parent().find('.shorts-play-conts').removeClass('on')
                }
            }
        }
        _$video.pauseTrigger = function () {
            if (!_$video.paused && isPlaying || !_$video.paused && _isVideoSrc) {
                _$video.pause();
                _$btnPlay.removeClass('on')
                if(_$btnPlay.parent().parent().find('.shorts-play-conts').length > 0){
                    _$btnPlay.parent().parent().find('.shorts-play-conts').addClass('on')
                }
            }
        }
        _$btnPlay.on('click', function (e) {
            if (_$video.paused && !isPlaying || _$video.paused && _isVideoSrc) {
                _$video.play();
                _$btnPlay.addClass('on')
                if(_$btnPlay.parent().parent().find('.shorts-play-conts').length > 0){
                    _$btnPlay.parent().parent().find('.shorts-play-conts').removeClass('on')
                }
                if($(this).data('ga')){
                    var obj = $(this).data('ga')
                    dataLayer.push(obj);	
                    //console.log(dataLayer);
                }
            } else {
                _$video.pause();
                _$btnPlay.removeClass('on')
                if(_$btnPlay.parent().parent().find('.shorts-play-conts').length > 0){
                    _$btnPlay.parent().parent().find('.shorts-play-conts').addClass('on')
                }
            }
        });
        _$btnMute.on('click', function (e) {
            if (_$video.muted) {
                _$video.muted = false;
                _$btnMute.addClass('on');
                _$btnMute.find('span').text('음소거');
            } else {
                _$video.muted = true;
                _$btnMute.removeClass('on');
                _$btnMute.find('span').text('음소거 해제');
            }
        });

        if (_$video.paused && !isPlaying || _$video.paused && _isVideoSrc) {
            _$btnPlay.removeClass('on')
            if(_$btnPlay.parent().parent().find('.shorts-play-conts').length > 0){
                _$btnPlay.parent().parent().find('.shorts-play-conts').addClass('on')
            }
        } else {
            _$btnPlay.addClass('on')
            if(_$btnPlay.parent().parent().find('.shorts-play-conts').length > 0){
                _$btnPlay.parent().parent().find('.shorts-play-conts').removeClass('on')
            }
        }
        if (_$video.muted) {
            _$btnMute.removeClass('on');
            _$btnMute.find('span').text('음소거 해제');
        } else {
            _$btnMute.addClass('on');
            _$btnMute.find('span').text('음소거');
        }
    }
    window.addEventListener('pageshow', function(e){
        $('.gram-story').css('min-height','auto');
    });
    $(document).ready(function () {
        MKTF30001.init();
        MKTF30001_HeroBnr.init();
        MKTF30001_Shorts.init();
        //  S : [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선 - 영역 제거로 비활성화
        // MKTF30001_RecomPc.init();
        // MKTF30001_RecomMo.init();
        //  E : [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선 - 영역 제거로 비활성화
    });
})();

